import { EventCustomRegFieldAvailValues } from './event-custom-reg-field-avail-values.model';

export class EventCustomRegFieldMin {
  public Id: number;
  public EventId: number;
  public DataType: string;
  public FieldName: string;
  public Visible: number;
  public Required: number;
  public StaffOnly: boolean;
  public DisplayOrder: number;
  public EventItemId: number;
  public AvailableValues: Array<EventCustomRegFieldAvailValues>;
  public Descr: string;
  public UnitsAvailable: number;
  public UnitsTaken: number;
  public ItemNum: number;
  public Amount: number;
  public UiControlType: string;
  public EventItemIds: Array<number>;

  public constructor() {
    this.Id = 0;
    this.EventId = 0;
    this.DataType = '';
    this.FieldName = '';
    this.Visible = 3;
    this.Required = 1;
    this.StaffOnly = false;
    this.DisplayOrder = 0;
    this.EventItemId = 0;
    this.AvailableValues = [];
    this.Descr = '';
    this.UnitsAvailable = 0;
    this.UnitsTaken = 0;
    this.ItemNum = 0;
    this.UiControlType = '';
    this.EventItemIds = new Array<number>();
  }
}
